import AppointmentServices from './AppointmentServices'

export default AppointmentServices